import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class CuttingParams extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }
  // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'CuttingParams';
  // Define default properties here
    static instanceDefaults() {
    return {
        product: '',
        thickness: '',
        cuttingOptions: {
            epsilon: 0.001,
            angleEpsilon: 0.00001,
            minimalCurveLength: 0.01,
            minimalExternalArea: 100,
            minimalExternalSpikeAngle: 160,
            minimalExternalSpikeRadius: 0.4,
            minimalExternalFilletAngle: 160,
            minimalExternalFilletRadius: 0.4,
            radiusPrecision: 0.05,
            minimalInternalArea: 5,
            minimalInternalSpikeAngle: 160,
            minimalInternalSpikeRadius: 0.4,
            minimalInternalFilletAngle: 160,
            minimalInternalFilletRadius: 0.4,
            flattenPrecision: 0.05,
            arcSegmentLengthTolerance: 0.03,
            arcSegmentCurvatureDeltaTolerance: 5,
            arcSegmentMaxCurvature: 18,
            minimalSegmentsCount: 3
        }
    }
  }
}
const servicePath = 'cuttingparams'
const servicePlugin = makeServicePlugin({
    Model: CuttingParams,
    service: feathersClient.service(servicePath),
    servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
